/**
 * Context definition for OfertaContext
 * Separated from Provider to support Fast Refresh
 */

import { createContext } from "react";

import type { OfertaCompleta } from "../models/oferta-personalizada";

export interface OfertaContextType {
  oferta: OfertaCompleta | null;
  /** Oferta original antes de editar (para calcular diff en analytics) */
  ofertaOriginal: OfertaCompleta | null;
  setOferta: (oferta: OfertaCompleta) => void;
  /** Guarda oferta original antes de iniciar edición */
  setOfertaOriginal: (oferta: OfertaCompleta) => void;
  clearOferta: () => void;
  updateOfertaPk: (pk: string) => void;
}

export const OfertaContext = createContext<OfertaContextType | undefined>(
  undefined
);

